export const usePageTitle = (title = '', meta) => {
    const { title: siteTitle } = meta || {};
    if (!siteTitle)
        return title;
    return title ? `${title} - ${siteTitle}` : siteTitle;
};
//# sourceMappingURL=usePageTitle.js.map